import Container from '../common/Container';
import Coverages from './Coverages';
import Codacy from './Codacy';


export default class Coverage extends Container {
  static Coverages = Coverages;
  static Codacy = Codacy;
}